module.exports = __webpack_public_path__ + "img/challeng-w.5075103d.png";